module.exports = __webpack_public_path__ + "img/rifle.96086f48.png";